<template>
  <div>
    <AppHeaderDropdown right no-caret>
      <template slot="header">
        <img
          v-if="hasCustomAvatar"
          :src="(currentUser.avatar.indexOf('/') > 0 ? '' : currentUser.remotePath + currentUser.avatarPath) + currentUser.avatar"
          class="img-avatar"
          :alt="currentUser.name" />
        <div v-else class="img-avatar avatar-placeholder-header">{{ avatarInitial }}</div>
      </template>\
      <template slot="dropdown">
          <b-list-group style="width:400px">

          <b-list-group-item href="#" class="flex-column align-items-start" variant="primary">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1"><small>{{ $store.state.currentUser.name ? $store.state.currentUser.name : "Usuário" }}</small></h5>
            </div>      
          </b-list-group-item>

          <b-list-group-item class="flex-column align-items-start">
            <b-dropdown-item  v-show="$store.state.currentUser.id" @click="goToDesktop()"><i class="icon-user text-primary"></i> Área de Trabalho</b-dropdown-item>
            <b-dropdown-item  @click="login"><i class="icon-login text-success"></i> {{ !$store.state.currentUser.id ? 'Entrar no Sistema' : 'Trocar usuário' }} </b-dropdown-item>
            <b-dropdown-item  @click="showLogoutModal()" v-show="$store.state.currentUser.id"><i class="icon-logout text-danger"></i> Sair do Sistema</b-dropdown-item>
          </b-list-group-item>
        
        </b-list-group>
  <!--
          <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
          <b-dropdown-item><i class="fa fa-bell-o" /> Updates
            <b-badge variant="info">{{ itemsCount }}</b-badge>
          </b-dropdown-item>
          <b-dropdown-item><i class="fa fa-envelope-o" /> Messages
            <b-badge variant="success">{{ itemsCount }}</b-badge>
          </b-dropdown-item>
          <b-dropdown-item><i class="fa fa-tasks" /> Tasks
            <b-badge variant="danger">{{ itemsCount }}</b-badge>
          </b-dropdown-item>
          <b-dropdown-item><i class="fa fa-comments" /> Comments
            <b-badge variant="warning">{{ itemsCount }}</b-badge>
          </b-dropdown-item>
          <b-dropdown-header
            tag="div"
            class="text-center">
            <strong>Configurações</strong>
          </b-dropdown-header>
          <b-dropdown-item><i class="fa fa-user" /> Profile</b-dropdown-item>
          <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>
          <b-dropdown-item><i class="fa fa-usd" /> Payments
            <b-badge variant="secondary">{{ itemsCount }}</b-badge>
          </b-dropdown-item>
          <b-dropdown-item><i class="fa fa-file" /> Projects
            <b-badge variant="primary">{{ itemsCount }}</b-badge>
          </b-dropdown-item>
          <b-dropdown-divider />
          <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item>
          <b-dropdown-item><i class="fa fa-lock" /> Logout</b-dropdown-item>
    -->
      </template>
    </AppHeaderDropdown>

    <!-- Logout Confirmation Modal -->
    <b-modal
      v-model="logoutModal"
      id="logout-modal"
      centered
      title="Confirmar Saída"
      header-bg-variant="danger"
      header-text-variant="light"
      @ok="confirmLogout"
      ok-title="Sim, Sair"
      ok-variant="danger"
      cancel-title="Cancelar"
      cancel-variant="secondary">
      <div class="d-flex align-items-center">
        <i class="fa fa-exclamation-triangle fa-3x text-warning mr-3"></i>
        <div>
          <p class="mb-2"><strong>Deseja realmente sair do sistema?</strong></p>
          <p class="mb-0 text-muted">Você será desconectado e redirecionado para a página inicial.</p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      ipAddress: '',
      logoutModal: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    hasCustomAvatar() {
      const user = this.currentUser;
      return !!(user && user.id && user.avatar && user.avatar !== 'img/noimage.png');
    },
    avatarInitial() {
      const user = this.currentUser;
      const name = user && user.id ? (user.name || '').trim() : '';
      return name ? name.charAt(0).toUpperCase() : 'U';
    }
  },
  mounted: function() {
    this.getIp()
  },
  methods: {
    async getIp() {
      axios.get('https://api.ipify.org?format=json')
        .then(response => {
            this.ipAddress = response.data.ip;
        })
        .catch(error => {
            console.log(error);
        });
    },
    showLogoutModal() {
      this.logoutModal = true;
    },
    confirmLogout() {
        const cookieMenu = this.$store.state.config.storageName

        this.logoutSystem(this.$store.state.currentUser.id, this.$store.state.currentUser.sid);

        if(this.$store.state.currentUser.id && this.$store.state.currentUser.id > 0) {
          this.$store.commit('SET_CURRENT_USER', {} )
          this.$store.commit('SET_CURRENT_UNIT', {} )

          localStorage.setItem(cookieMenu + '_MENU',null)
          localStorage.setItem(cookieMenu + '_USER',null)
          //this.$cookies.set("smg_user",null,-1)
          this.$store.commit('SET_MENU', [
                      {
                        name: 'Portal',
                        url: '/dashboard',
                        icon: 'icon-speedometer'
                      }
                    ])
        }
        //this.$router.push({ path: '/pages/login' })
        this.$router.push({ path: '/dashboard' }).catch(()=>{});
        this.logoutModal = false;
    },
    login() {
      this.$router.push({ path: '/pages/login' })
    },

    goToDesktop() {
      this.$router.push({ path: '/controlpanel' })
    },

    async logoutSystem(currentUserId, currentUserSid) {
      
      var s = this;
      const requestOptions = {
        body: JSON.stringify()
      }

      //console.log("Logout efetuado.")

      await axios.post(
          this.$store.state.ws_url + "/logout",
          {
            "uid": currentUserId,
            "sid": currentUserSid,
            "ip": this.ipAddress
          }          
      ).then(function(resp) {
        //console.log('Logou efetuado com sucesso.')
      }).catch(function (error) {
        s.errormessage = error.response.data.obj.message;        
      });

      
    }

  }
}
</script>

<style scoped>
.avatar-placeholder-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  background-color: #20a8d8;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  user-select: none;
}
</style>
